"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _text = require("../text");

var _utils = require("../utils");

var _constants = require("./constants");

var ModalTitleBase = _text.Text.withComponent('h2', {
  target: "e1edvb7w0"
});

var ModalTitleWithoutDocs = (0, _utils.withTestAttributes)({
  component: 'StencilModalTitle'
})(ModalTitleBase);
var ModalTitle = (0, _stencilReactDesc.describe)(ModalTitleWithoutDocs).description('Text to display at the top of a modal.');
ModalTitle.propTypes = (0, _objectSpread2.default)({}, _text.Text.describedPropTypes);
ModalTitle.defaultProps = (0, _objectSpread2.default)({}, _text.Text.defaultProps, _constants.ModalTitleDefaultProps);
ModalTitle.displayName = 'ModalTitle';
var _default = ModalTitle;
exports.default = _default;